<template>
  <v-dialog v-model="visible" persistent max-width="780">
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.relatedCompanies`) }}</span>
        <v-btn class="v-dialog--custom__close mr-2" fab flat color="gray-6" @click.native="close">
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-0">
        <div class="table">
          <v-layout class="table__header bg-custom" align-center>
            <v-flex>{{ $t('Common.company') | capitalizeFirstLetter }}</v-flex>
          </v-layout>

          <v-list subheader two-line class="table__body">
            <div v-for="(item, i) in items" :key="`tr-${i}`">
              <v-list-tile class="table__body__tr">
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-layout align-center>
                      <v-flex>
                        <span class="text--ellipsis">{{ item.name }}</span>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider />
            </div>
          </v-list>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CompaniesDialog',
  props: {
    items: {
      type: Array,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.ConsolidatedReportsPage'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.table__header.bg-custom {
  background-color: #f6f6f6 !important;
  min-width: auto !important;
}

.table {
  overflow: hidden;
  max-width: auto;
  max-height: 480px;
}

.table__body {
  overflow-y: auto;
  min-width: auto;
  max-height: 420px;
}

.table__body__tr .v-list__tile__content, .table__body__tr .v-list__tile__sub-title {
  overflow: auto;
}
</style>
